module.exports = {"deliveryDate":true,"deliveryPostalCode":true,"deliveryPeriodMorning":true,"deliveryPeriodAfternoon":true}


//////////////////
// WEBPACK FOOTER
// ./src/schemas/filters/sortOrders.json
// module id = zuns
// module chunks = 1